import styled from 'styled-components'
import { GroupPill, LinkText } from '../../PublisherPersons.styles'

export const PersonName = styled.span`
  font-weight: 500;
  font-size: 14px;
`

export const AccordionCount = styled.span`
  margin-left: auto;
  font-size: 12px;
  opacity: 0.6;
`

export const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 16px;
  border-bottom: 0.5px solid #eee;
`

export const PersonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 0.5px solid #eee;
`

export const GroupPillRemovable = styled(GroupPill)`
  gap: 4px;
  cursor: default;
`

export const GroupPillRemoveBtn = styled.span`
  cursor: pointer;
  margin-left: 4px;
  opacity: 0.6;
  font-size: 11px;
  &:hover {
    opacity: 1;
  }
`

export const AddGroupRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-top: 0.5px solid #eee;
`

export const AddProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 0.5px solid #eee;
`

export const AddProfileBtn = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-bottom: 0.5px solid #eee;
`

export const PlatformSelect = styled.select`
  height: 34px;
  padding: 0 8px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 13px;
  width: 120px;
  flex-shrink: 0;
  background: transparent;
  color: inherit;
`

export const GroupTagsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
`

export const GroupsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const ProfilesRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`

export const ModeSelector = styled.div`
  display: flex;
  align-items: center;
  border: 0.5px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
`

export const ModeSelectorBtn = styled.button<{ $active: boolean }>`
  height: 36px;
  padding: 0 14px;
  font-size: 13px;
  border: none;
  border-right: 0.5px solid #ddd;
  background: ${({ $active }) => ($active ? '#f5f5f5' : 'transparent')};
  font-weight: ${({ $active }) => ($active ? 500 : 400)};
  cursor: pointer;

  &:last-child {
    border-right: none;
  }
`

export const AddGroupTagWrapper = styled.div`
  flex: 1;
`

export const ProfileLinkText = styled(LinkText)`
  flex: 1;
  font-size: 13px;
  max-width: unset;
`
